module.exports = __webpack_public_path__ + "img/Step05b.0832e60a.webp";